<template>
  <div class="oldnew-search">
    <div class="search">
      <div class="search-box">
        <img
          :src="require('../../../../common/images/oldnew/search.png')"
          alt=""
          class="img-left"
        />
        <input
          @input="inputHandle"
          @change="searchHandle"
          v-model="searchData"
          type="search"
        />
        <div class="img-wrap">
          <img
            v-show="searchData.length"
            @click="clearTextHandle"
            :src="require('../../../../common/images/oldnew/close.png')"
            alt=""
          />
        </div>
      </div>
      <span @click="searchHandle" class="cancel">搜索</span>
    </div>
    <div class="line-through"></div>

    <!-- 历史记录 -->
    <history v-if="!searchData.length" />
    <!-- 列表页 -->
    <!-- -->
    <list
      v-show="
        searchData.length &&
          (computeTotalIshow(totalSale) || computeTotalIshow(totalAdviser))
      "
      ref="list"
      :listData="listData"
      :totalSale="totalSale"
      :totalAdviser="totalAdviser"
    />
    <!-- 搜索结果为空 -->
    <div
      v-if="
        isShow &&
          searchData.length &&
          !computeTotalIshow(totalSale) &&
          !computeTotalIshow(totalAdviser)
      "
      class="result-null"
    >
      <div class="img">
        <img
          :src="require('../../../../common/images/oldnew/null.png')"
          alt=""
        />
      </div>
      <div class="tips">
        非常抱歉
        <br />
        没找到相关内容
      </div>
    </div>
    <!-- loading -->
    <loading :show="loadingStatus"></loading>
  </div>
</template>

<script>
import history from "./components/history";
import list from "./components/list";
import loading from "@/components/loading";
import * as api from "../../../../api/modules/search.js";
export default {
  data() {
    return {
      searchData: "",
      current: 1,
      size: 10,
      status: -2,
      // 列表数据
      listData: [],
      finished: false,
      totalSale: {},
      totalAdviser: {},
      isShow: false,
      terminal: "",
      loadingStatus: false,
    };
  },
  components: {
    history,
    list,
    loading,
  },
  activated() {
    if (
      localStorage.getItem("pageFrom") === "/auditDetail" ||
      localStorage.getItem("pageFrom") === "/progressDetail"
    ) {
      this.current = 1;
      this.$refs["list"].clearTotalArr();
      this.loadList();
      this.loadTabsList();
    }
  },

  beforeRouteLeave(to, from, next) {
    if (to.path === "/progress" || to.path === "/OldNew") {
      // 初始化
      this.searchData = "";
      this.listData = [];
      this.totalSale = {};
      this.totalAdviser = {};
      this.$refs["list"].init();
    }

    next();
  },
  methods: {
    // 计算统计是否有数据
    computeTotalIshow(data) {
      let arr = [];
      for (let i in data) {
        arr.push(data[i]);
      }
      return arr.some((item) => {
        return item > 0;
      });
    },
    //销售经理将新状态转换老状态码
    saleNewStatusToOld(newCode) {
      let map = {
        "0": "pendding",
        "1": -5,
        "2": -1,
        "3": "0",
        "4": 1,
        "5": 3,
        "6": 2,
        "7": 4,
      };
      return map[`${newCode}`] || "other";
    },
    // 销售经理端老状态转换新状态
    saleOldStatusToNew(old) {
      let map = {
        "-5": 1,
        "-1": 2,
        "0": 3,
        "1": 4,
        "3": 5,
        "2": 6,
        "4": 7,
        "-3": "0",
        "-4": "0",
        // 全部
        "-2": "0,1,2,3,4,5,6,7",
      };
      return map[`${old}`] || "";
    },
    //置业顾问端新状态转换老状态
    adviserNewStatusToOld(newCode) {
      let map = {
        "2": -1,
        "3": "0",
        "4": 1,
        "5": 3,
        "6": 2,
        "7": 4,
      };
      return map[`${newCode}`] || "other";
    },
    //置业顾问端老状态转换新状态
    adviserOldStatusToNew(old) {
      let map = {
        "-1": 2,
        "0": 3,
        "1": 4,
        "3": 5,
        "2": 6,
        "4": 7,
        // 全部
        "-2": "2,3,4,5,6,7",
      };
      return map[`${old}`] || "";
    },
    // 改变status和current
    changeStatusCurrents(c, s) {
      this.current = c;
      this.status = s;
    },
    // 查询数据
    searchHandle(data) {
      this.isShow = false;
      this.status = -2;
      this.current = 1;
      this.listData = [];

      // 子组件调用
      if (data && typeof data != "object") {
        this.searchData = data;
        this.$forceUpdate();
      }
      // 开始遮罩层
      this.searchData && (this.loadingStatus = true);
      // 初始化数据
      this.$refs["list"].init();
      setTimeout(() => {
        this.searchData && this.saveHsData(this.searchData);

        this.loadTabsList();
        this.loadList();
      }, 0);
    },
    // 获取相应的列表数据
    loadList() {
      // 获取数据
      let params = {
        query: this.searchData,
        current: this.current,
        size: this.size,
        status: this.status,
        projectCode: this.$route.query.projectCode,
        orgCode: this.$route.query.orgCode,
      };
      this.finished = false;
      // 销售经理端
      if (this.$route.query.type == 1 && this.searchData) {
        params.requestEntry = 1;
        params.statuses = this.saleOldStatusToNew(params.status);
        // 如果status为老业主或者合资待审传methods字段
        if (params.status === -3) {
          params.method = 0;
        } else if (params.status === -4) {
          params.method = 2;
        }
        // 获取
        api
          .searchSaleManager(params)
          .then((res) => {
            this.listData = res.body.records;
            // 关闭遮罩层
            this.loadingStatus = false;
            this.$nextTick(() => {
              (res.body.pages == res.body.current ||
                res.body.pages == 0 ||
                res.body.records.length == 0) &&
                this.$refs["list"].changeFinished();
              this.$refs["list"].closeLoading();
              this.$refs["list"].changeCurrent();
              this.$refs["list"].changeGoOnStatus();
            });
          })
          .catch((err) => {
            // 关闭遮罩层
            this.loadingStatus = false;
            this.listData = [];
            this.finished = true;
            this.$nextTick(() => {
              this.$refs["list"].closeLoading();
              this.$refs["list"].changeGoOnStatus();
            });
          });
      }
      // 置业顾问端
      if (this.$route.query.type == 2 && this.searchData) {
        params.requestEntry = 2;
        // 转换状态码
        params.statuses = this.adviserOldStatusToNew(params.status);
        api
          .searchAdviser(params)
          .then((res) => {
            this.listData = res.body.records;
            // 关闭遮罩层
            this.loadingStatus = false;
            this.$nextTick(() => {
              (res.body.pages == res.body.current ||
                res.body.pages == 0 ||
                res.body.records.length == 0) &&
                this.$refs["list"].changeFinished();
              this.$refs["list"].closeLoading();
              this.$refs["list"].changeCurrent();
              this.$refs["list"].changeGoOnStatus();
            });
          })
          .catch((err) => {
            // 关闭遮罩层
            this.loadingStatus = false;
            this.listData = [];
            this.finished = true;
            this.$nextTick(() => {
              this.$refs["list"].closeLoading();
              this.$refs["list"].changeGoOnStatus();
            });
          });
      }
    },
    // 保存搜索记录到本地
    saveHsData(data) {
      let hsData = JSON.parse(localStorage.getItem("oldNewHistory")) || [];
      if (hsData.includes(data)) return;
      hsData.length === 5 && hsData.pop();
      hsData.unshift(data);
      localStorage.setItem("oldNewHistory", JSON.stringify(hsData));
    },
    // 清空数据
    clearTextHandle() {
      this.searchData = "";

      this.totalSale = {};
      this.totalAdviser = {};
      this.$refs["list"].init();
    },
    // 输入值
    inputHandle(eve) {
      // console.log(this.searchData, "值变化");
      this.listData = [];
      this.totalSale = {};
      this.totalAdviser = {};
      this.$refs["list"].init();

      let regRule = /[^\u4E00-\u9FA5|\d|\a-zA-Z|\r\n\s]|\s/g;
      this.searchData = this.searchData.replace(regRule, "");
    },
    // 查询菜单统计
    loadTabsList() {
      // 获取数据
      let params = {
        query: this.searchData,
        statuses: "0,1,2,3,4,5,6,7,8,9",
        projectCode: this.$route.query.projectCode,
        orgCode: this.$route.query.orgCode,
      };
      // 销售经理端
      if (this.$route.query.type == 1 && this.searchData) {
        params.requestEntry = 1;
        api
          .searchSaleManagerTatol(params)
          .then((res) => {
            this.totalSale = res.body.reduce((total, item) => {
              total[`${this.saleNewStatusToOld(item.status)}`] = item.total;
              return total;
            }, {});

            this.isShow = true;
          })
          .catch((err) => {
            this.isShow = false;
            this.totalSale = {};
            this.$toast(err);
          });
      }
      // 置业顾问端
      if (this.$route.query.type == 2 && this.searchData) {
        params.requestEntry = 2;
        api
          .searchAdviserTatol(params)
          .then((res) => {
            this.totalAdviser = res.body.reduce((total, item) => {
              total[`${this.adviserNewStatusToOld(item.status)}`] = item.total;
              return total;
            }, {});
            console.log(this.totalAdviser, "置业顾问统计");
            this.isShow = true;
          })
          .catch((err) => {
            this.isShow = false;
            this.totalAdviser = {};
            this.$toast(err);
          });
      }
    },
    // 判断是安卓还是苹果
    ios_or_android() {
      var u = navigator.userAgent;
      var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

      if (isAndroid) {
        return "and";
      } else {
        return "ios";
      }
    },
  },
  created() {
    // 判断角色设置status
    // this.terminal = this.ios_or_android();
    // 设置标题
    document.title = "老带新推荐";
    console.log("构建成功-14.51");
  },
};
</script>

<style lang="scss">
.oldnew-search {
  height: 100%;
  display: flex;
  flex-flow: column;
  .reback-btn {
    display: flex;
    font-size: 32px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 44px;
    align-items: center;
    margin-top: 30px;
    img {
      width: 18px;
      height: 28px;
      margin-right: 28px;
      margin-left: 26px;
    }
  }
  .line-through {
    border-top: 1px solid #dddddd;
  }
  .search {
    padding: 30px 30px 0px 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;

    .search-box {
      display: flex;
      align-items: center;
      padding-right: 20px;
      width: 594px;
      height: 72px;
      background: #f2f2f2;
      border-radius: 36px;
      .img-left {
        margin: 0 30px;
        height: 32px;
        width: 32px;
      }
      .img-wrap {
        margin-left: 20px;
        height: 36px;
        width: 36px;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
        }
      }

      input {
        width: 416px;
        height: 48px;
        font-size: 34px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 48px;
        border: none;
        outline: none;
        background: #f2f2f2;
      }
      input::-webkit-search-cancel-button {
        display: none;
      }
    }
    .cancel {
      font-size: 32px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #0d9869;
    }
  }
  .content {
    flex: 1;
  }
  .result-null {
    margin-top: 294px;
    text-align: center;
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #666666;
    line-height: 44px;

    .img {
      margin-bottom: 8px;
      width: 416px;
      height: 230px;
      margin: auto;
      img {
        width: inherit;
        height: inherit;
      }
    }
  }
  .loading-wrap {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
